<template>
    <div class="list-wrap">
        <img :width="imageWidth" :height="imageHeight" :class="{circular:circular}" :src="imageUrl"/>
        <div class="content">
            <slot name="info"></slot>
        </div>
        <IconBtn
                :publish="publish"
                class="btns"
                @on-submit="onSent"
                @on-unpub="onUnPub"
                @on-edit="onEdit"
                @on-del="onDel"
        ></IconBtn>
        <span class="lang">{{lang?'EN':'ZH'}}</span>
    </div>
</template>
<script>
    import IconBtn from "../components/kllk-operator-btn";

    export default {
        components: {
            IconBtn
        },
        props: {
            imageUrl: String,
            imageWidth:{
                type:Number,
                default:90
            } ,
            imageHeight:{
                type:Number,
                default:90
            },
            circular:Boolean,
            lang:Number,
            publish:Boolean,
        },
        data() {
            return {};
        },
        methods: {
            onSent() {
                this.$emit("on-sent");
            },
            onUnPub() {
                this.$emit("on-unpub");
            },
            onEdit() {
                this.$emit("on-edit");
            },
            onDel() {
                this.$emit("on-del");
            },
            onView() {
                this.$emit("on-view");
            }
        }
    };
</script>
<style lang="less" scoped>
    .list-wrap {
        width: 97%;
        margin-bottom: 15px;
        position: relative;
        display: flex;
        padding: 15px;
        align-items: center;
        overflow: hidden;
        box-shadow: 2px 2px 5px #dcdcdc;
        img{
            object-fit: fill;
        }
        .content{
            flex: 1;
            width: 70%;
        }
        .btns{
            flex-shrink: 0;
        }
        .lang{
            position: absolute;
            top: -5px;
            right: -15px;
            z-index: 99;
            font-size: 12px;
            padding: 10px 15px 0 15px;
            transform: rotate(45deg);
            color: #ffffff;
            background-color: #46B5FF;
        }
    }
    .circular{
        border-radius: 50%;
    }
</style>
